import { v4 as uuidv4 } from 'uuid';
import Button, { Color } from 'lib/Button';
import { DEFAULT_PAGE_SIZES } from 'consts/pagination';

type PageSizeProps = {
  pageSize: number;
  onPageSizeChange: (pageSize: number) => void;
  dataTestId?: string;
  pageInfoText?: string;
  listOfPageSizes?: number[];
};

const PageSize = ({
  dataTestId = '',
  pageInfoText = '',
  onPageSizeChange,
  pageSize,
  listOfPageSizes = DEFAULT_PAGE_SIZES,
}: PageSizeProps): React.ReactElement => {
  return (
    <div className="flex items-center text-neutral-950-opacity-60" data-test-id={dataTestId}>
      <span className="mr-1 sub-header-sm">Display</span>
      {listOfPageSizes.map((size) => (
        <span className="mx-1" key={uuidv4()}>
          <Button
            onClick={() => {
              onPageSizeChange(size);
            }}
            color={pageSize === size ? Color.PRIMARY : Color.SECONDARY}
            classNames="!px-1 !rounded"
          >
            {size}
          </Button>
        </span>
      ))}
      <span className="ml-1 sub-header-sm">{pageInfoText}</span>
    </div>
  );
};

export default PageSize;
